import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { Session } from 'types';
import { client } from 'utils/api-client';

export function getSession(): Promise<AxiosResponse<Session>> {
  return client.get('/auth/session/');
}

export default function useSession(): UseQueryResult<{ data: Session }> {
  return useQuery(['session'], getSession, {
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
    retry: false,
  });
}
